import { DisplayWhenHasModules } from 'components.layouts/five-up/five-up-utils.js';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { memo } from 'react';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';

/** Important only update overlay content when layout props change */
export const OverlayContent = memo(({ layout }: { layout?: ILayoutConfig }) => {
  const { main, rightMajor } = layout?.primary?.slots ?? {};
  return (
    <div className="Grid Grid--withGutter">
      <div className="Grid-cell two-thirds">
        <DisplayWhenHasModules section={main}>
          <ModulesLazyLoadWrapper section={getModulesMetaData('overlay-main', main?.modules)}>
            <ModuleArrLoad modules={main?.modules} modulePath={ModulePath.PRIMARY_MAIN} />
          </ModulesLazyLoadWrapper>
        </DisplayWhenHasModules>
      </div>

      <div className="Grid-cell u-md-width1of3 u-sm-hidden">
        <DisplayWhenHasModules section={rightMajor}>
          <ModulesLazyLoadWrapper section={getModulesMetaData('overlay-rightMajor', rightMajor?.modules)}>
            <ModuleArrLoad modules={rightMajor?.modules} modulePath={ModulePath.PRIMARY_RIGHT_MAJOR} />
          </ModulesLazyLoadWrapper>
        </DisplayWhenHasModules>
      </div>
    </div>
  );
});
